import request from '@/axios'

/**
 * @Description: 获取应用软件推荐
 */
export function getAllGMOSApp(data){
  return request({
    method: 'get',
    url: '/api/Applys/selectApplysList',
    params: data
  })
}
